import { render } from "./TestimonialSlider.vue?vue&type=template&id=492e5645"
import script from "./TestimonialSlider.vue?vue&type=script&lang=js"
export * from "./TestimonialSlider.vue?vue&type=script&lang=js"

import "./TestimonialSlider.vue?vue&type=style&index=0&id=492e5645&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\New folder\\Lynkme360\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__